/**
 * The access token, held in memory for the life of the page and nowhere else.
 *
 * DELIBERATE S1 TRADEOFF — this is the decision record for token storage:
 *
 *   The token is NOT written to `localStorage` or `sessionStorage`, and there is
 *   no "remember me". Web storage is readable by any script on the origin, so a
 *   single XSS exfiltrates the token; and a stolen token is valid for its whole
 *   `ACCESS_TOKEN_TTL_SECONDS` hour with no server-side way to cut it short mid-flight.
 *   Keeping it in a module-scoped variable means an attacker must already be executing
 *   in the page to reach it — at which point they have the session anyway — and closing
 *   the tab drops this token for real.
 *
 *   UPDATED BY adr/0021 — READ THIS BEFORE ASSUMING A RELOAD SIGNS THE USER OUT: it no
 *   longer does. This package's own statelessness is UNCHANGED — the module-scoped
 *   variable below is still gone the instant the page reloads, and it is still never
 *   persisted here. What changed is that the API now also issues a separate, `HttpOnly`
 *   durable session cookie at login — one a script on this origin cannot read at all —
 *   and `AuthProvider` exchanges it for a fresh access token on every app start
 *   (`auth.refreshSession()`, see `auth-provider.tsx` and
 *   `components/require-auth.tsx`'s loading state). So a reload costs one extra round
 *   trip before the app can tell whether there is a session, not a sign-out. Do NOT
 *   "fix" this store's statelessness with `localStorage` persistence: that would put the
 *   bearer token somewhere every script on the origin can read it, for zero benefit now
 *   that adr/0021's `HttpOnly` cookie already solves "a reload signs you out" properly.
 *
 * It lives here rather than in React state alone because the SDK transport asks
 * for the token through a plain `getAuthToken()` callback, outside the React
 * tree. `AuthProvider` owns the session in state and keeps this store in step;
 * nothing else may write it.
 */
let accessToken = null;
/** Handed to `createClient({ getAuthToken })`. */
export function getAccessToken() {
    return accessToken;
}
/** Called only by `AuthProvider` — on sign-in, on sign-out, and on session loss. */
export function setAccessToken(next) {
    accessToken = next;
}
//# sourceMappingURL=access-token-store.js.map